import React from 'react';
import { Empty } from 'antd';

const NotFound = () => {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="Ничего не найдено"
    />
  );
};

export default NotFound;
